import React, { useContext } from 'react';
import proptypes from 'prop-types';
const { shape, func, string, bool } = proptypes;
import { ExperienceContext, useStore, useConfigService } from '@thd-nucleus/experience-context';
import { CheckNearByStore } from './CheckNearbyStore';
import { productShape } from '../../helpers/pod-fulfillment-utils';
import { UnavailableIcon } from '../../helpers/icon-utils';
import { isFunction, isMobile } from '../../../components/helper/utils';
import { PICKUP_TEMPLATES } from '../../templates/templatesConstant';
import { PodMessage } from '../PodMessage';

export const NoStoreOption = ({
  storeMessage = 'Unavailable',
  enableOverlayLink = true,
  product,
  onCheckNearbyStoresClick = () => {},
  excludedState = '',
  customRender = null,
  isNarrowPod = false
}) => {
  const { channel } = useContext(ExperienceContext);
  const enablePLPFasterDeliveryOption = !!useConfigService('fs:enablePLPFasterDeliveryOption');
  const { storeName } = useStore();

  const overlayLink = (isMobile(channel) && !excludedState)
    ? <span className="sui-text-primary">{storeName}</span>
    : (
      <CheckNearByStore
        product={product}
        onCheckNearbyStoresClick={onCheckNearbyStoresClick}
        excludedState={excludedState}
      />
    );

  if (isFunction(customRender)) {
    return customRender(
      { pickUpTemplate: PICKUP_TEMPLATES.NO_STORE_OPTION,
        icon: UnavailableIcon,
        values:
        { message: storeMessage, overlayLink, enableOverlayLink, storeName } });
  }

  return (
    <PodMessage
      messageIcon={UnavailableIcon}
      messageType="Pickup"
      isStoreNameAtEnd={enableOverlayLink && enablePLPFasterDeliveryOption}
      isNarrowPod={isNarrowPod}
    >
      <>
        <span className="sui-text-subtle">{storeMessage}</span>
        {enableOverlayLink && overlayLink}
      </>
    </PodMessage>
  );
};

NoStoreOption.propTypes = {
  enableOverlayLink: bool,
  onCheckNearbyStoresClick: func,
  product: shape({ productShape }).isRequired,
  storeMessage: string,
  excludedState: string,
  customRender: func,
  isNarrowPod: bool
};

NoStoreOption.displayName = 'NoStoreOption';
